// export
import { BASE_URL } from "constant";
import privateFetch from "PrivateFetch";

// INITIAL STATE
export const INITIAL_STATE = {
    status: "",
    loading: false,
    data: [],
    error: false,
};

// CONSTANTA
export const DOKTER_PROVINSI_LOADING = "DOKTER_PROVINSI_LOADING";
export const DOKTER_PROVINSI_SUCCESS = "DOKTER_PROVINSI_SUCCESS";
export const DOKTER_PROVINSI_ERROR = "DOKTER_PROVINSI_ERROR";

export const DOKTER_KOTA_LOADING = "DOKTER_KOTA_LOADING";
export const DOKTER_KOTA_SUCCESS = "DOKTER_KOTA_SUCCESS";
export const DOKTER_KOTA_ERROR = "DOKTER_KOTA_ERROR";

export const DOKTER_GET_LOADING = "DOKTER_GET_LOADING";
export const DOKTER_GET_SUCCESS = "DOKTER_GET_SUCCESS";
export const DOKTER_GET_ERROR = "DOKTER_GET_ERROR";

export const DOKTER_SAVE_LOADING = "DOKTER_SAVE_LOADING";
export const DOKTER_SAVE_SUCCESS = "DOKTER_SAVE_SUCCESS";
export const DOKTER_SAVE_ERROR = "DOKTER_SAVE_ERROR";

export const DOKTER_UPDATE_LOADING = "DOKTER_UPDATE_LOADING";
export const DOKTER_UPDATE_SUCCESS = "DOKTER_UPDATE_SUCCESS";
export const DOKTER_UPDATE_ERROR = "DOKTER_UPDATE_ERROR";

export const DOKTER_DELETE_LOADING = "DOKTER_DELETE_LOADING";
export const DOKTER_DELETE_SUCCESS = "DOKTER_DELETE_SUCCESS";
export const DOKTER_DELETE_ERROR = "DOKTER_DELETE_ERROR";

export const DOKTER_LIST_LOADING = "DOKTER_LIST_LOADING";
export const DOKTER_LIST_SUCCESS = "DOKTER_LIST_SUCCESS";
export const DOKTER_LIST_ERROR = "DOKTER_LIST_ERROR";

// const dispatch

const dokterProvinsiLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_PROVINSI_LOADING,
        loading: bool,
    };
};

const dokterProvinsiSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_PROVINSI_SUCCESS,
        data,
    };
};

const dokterProvinsiError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_PROVINSI_ERROR,
        error: bool,
    };
};

const dokterKotaLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_KOTA_LOADING,
        loading: bool,
    };
};

const dokterKotaSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_KOTA_SUCCESS,
        data,
    };
};

const dokterKotaError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_KOTA_ERROR,
        error: bool,
    };
};

const dokterGetLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_GET_LOADING,
        loading: bool,
    };
};

const dokterGetSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_GET_SUCCESS,
        data,
    };
};

const dokterGetError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_GET_ERROR,
        error: bool,
    };
};

const dokterSaveLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_SAVE_LOADING,
        loading: bool,
    };
};

const dokterSaveSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_SAVE_SUCCESS,
        data,
    };
};

const dokterSaveError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_SAVE_ERROR,
        error: bool,
    };
};

const dokterUpdateLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_UPDATE_LOADING,
        loading: bool,
    };
};

const dokterUpdateSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_UPDATE_SUCCESS,
        data,
    };
};

const dokterUpdateError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_UPDATE_ERROR,
        error: bool,
    };
};

const dokterDeleteLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_DELETE_LOADING,
        loading: bool,
    };
};

const dokterDeleteSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_DELETE_SUCCESS,
        data,
    };
};

const dokterDeleteError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_DELETE_ERROR,
        error: bool,
    };
};

const dokterListLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_LIST_LOADING,
        loading: bool,
    };
};

const dokterListSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_LIST_SUCCESS,
        data,
    };
};

const dokterListError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: DOKTER_LIST_ERROR,
        error: bool,
    };
};

// function export
export function dokterProvinsi() {
    let url = BASE_URL + "province/list";
    return privateFetch(
        dokterProvinsiSuccess,
        dokterProvinsiError,
        dokterProvinsiLoading,
        "POST",
        url,
        ""
    );
}

export function dokterKota(data) {
    let url = BASE_URL + "city/list";
    return privateFetch(dokterKotaSuccess, dokterKotaError, dokterKotaLoading, "POST", url, data);
}

export function dokterGet(data) {
    let url = BASE_URL + "dokter/page";
    return privateFetch(dokterGetSuccess, dokterGetError, dokterGetLoading, "POST", url, data);
}

export function dokterSave(data) {
    let url = BASE_URL + "dokter/save";
    return privateFetch(dokterSaveSuccess, dokterSaveError, dokterSaveLoading, "POST", url, data);
}

export function dokterUpdate(data) {
    let url = BASE_URL + "dokter/update";
    return privateFetch(
        dokterUpdateSuccess,
        dokterUpdateError,
        dokterUpdateLoading,
        "POST",
        url,
        data
    );
}

export function dokterDelete(data) {
    let url = BASE_URL + "dokter/delete";
    return privateFetch(
        dokterDeleteSuccess,
        dokterDeleteError,
        dokterDeleteLoading,
        "POST",
        url,
        data
    );
}

export function dokterList(data) {
    let url = BASE_URL + "dokter/list";
    return privateFetch(dokterListSuccess, dokterListError, dokterListLoading, "POST", url, data);
}
